// User.js
export const User = {
  me: async () => ({
    email: "user@example.com",
    full_name: "Sample User"
  })
};
